const { default: Axios, default: axios } = require("axios");
const { countBy, each, constant, default: _ } = require("lodash");

import Loader from './../components/Loader.js';
import utilities from './../components/utilities.js';
const classUtilitites = new utilities;


function qtyChange() {
    var element = $(this);

    var type = element.data('type');
    var id = element.closest('tr').data('id');
    var qty = element.closest('tr').find('.qty-product').val();

    if (type == 'plus') {
        qty++;
    } else {
        qty--;
    }

    if (qty < 1 && element.attr('data-min_product') === undefined) {
        qty = 1;
    }

    if (element.attr('data-min_product') !== undefined) {
        let minProduct = element.attr('data-min_product');
        if (qty < minProduct) {
            qty = minProduct;
        }
    }

    element.closest('tr').find('.qty-product').val(qty);

    let url = '/proposal/item/order-item/' + id;
    if (element.data('url')) {
        url = element.data('url');
    }

    Loader.wrap(Axios.post(url, {
        qty: qty
    })).then(function (response) {
        var response = response.data;

        if (response.error) {
            showAlert(response.message, "Ok", "error");    
            if (element.attr('data-min_product') !== undefined) {
                let minProduct = element.attr('data-min_product');
                element.closest('tr').find('.qty-product').val(minProduct);
            }        
        } else {

            var data = response.result;

            var item = data.item;
            var order = data.order;
            let parent_item = data.parent_item;

            $('#product-' + item.id).find('.total-product').text(item.total_product);

            $('.order-info').find('.products-price').text(order.products_price);
            $('.order-info').find('.shipping-price').text(order.shipping_price);
            $('.order-info').find('.tax').text(order.tax);
            $('.order-info').find('.discount').text(order.discount);
            $('.order-info').find('.price').text(order.price);      
            
            if (order.order_type_id == 5 && typeof parent_item.id !== 'undefined') {
                $('#product-' + parent_item.id).find('.qty-product').text(parent_item.qty);
                $('#product-' + parent_item.id).find('.total-product').text(parent_item.total_product);                
            }
        }
    }).catch((error) => classUtilitites.showCommunicationError(error));
}

function qtyProduct() {
    var element = $(this);

    var id = element.closest('tr').data('id');
    var qty = element.val();

    let url = '/proposal/item/order-item/' + id;
    if (element.data('url')) {
        url = element.data('url');
    }

    Loader.wrap(Axios.post(url, {
        qty: qty
    })).then(function (response) {
        var data = response.data.result;

        var item = data.item;
        var order = data.order;
        let parent_item = data.parent_item;

        $('#product-' + item.id).find('.total-product').text(item.total_product);

        $('.order-info').find('.products-price').text(order.products_price);
        $('.order-info').find('.shipping-price').text(order.shipping_price);
        $('.order-info').find('.tax').text(order.tax);
        $('.order-info').find('.discount').text(order.discount);
        $('.order-info').find('.price').text(order.price);
        
        if (order.order_type_id == 5 && typeof parent_item.id !== 'undefined') {
            $('#product-' + parent_item.id).find('.qty-product').text(parent_item.qty);
            $('#product-' + parent_item.id).find('.total-product').text(parent_item.total_product);                
        }
    }).catch((error) => classUtilitites.showCommunicationError(error));
}

function componentQty() {
    var element = $(this);

    classUtilitites.calculateComposition();
}

function discountItem() {
    var element = $(this);

    var discount = parseFloat(element.val());
    var type = element.data('type');
    var original = element.data('original');
    var id = element.closest('tr').data('id');
    var max = parseFloat(element.attr('max'));

    if (discount > max) {
        showAlert('Desconto acima do valor permitido');

        element.val(0);
        element.trigger('change');
        return false;
    }

    let url = '/proposal/item/order-item/' + id;
    if (element.data('url')) {
        url = element.data('url');
    }

    Loader.wrap(Axios.post(url, {
        discount: discount,
        original: original,
        type: type
    })).then(function (response) {
        var data = response.data.result;

        let parent_item = data.parent_item;
        var item = data.item;
        var order = data.order;

        $('#product-' + item.id).find('.discount-item-percent').val(item.discount_percent);
        $('#product-' + item.id).find('.discount-item-value').val(item.discount_value);
        $('#product-' + item.id).find('.discount-item-newValue').val(item.new_value);
        $('#product-' + item.id).find('.total-product').text(item.total_product);

        if (item.contribution) {
            $('#product-' + item.id).find('.contribution-item').text(item.contribution); 
        }        

        if (typeof parent_item.id !== 'undefined') {
            $('#product-' + parent_item.id).find('.discount-item-percent').val(parent_item.discount_percent);
            $('#product-' + parent_item.id).find('.discount-item-percent').text(parent_item.discount_percent);
            $('#product-' + parent_item.id).find('.discount-item-value').val(parent_item.discount_value);
            $('#product-' + parent_item.id).find('.discount-item-value').text(parent_item.discount_value);
            $('#product-' + parent_item.id).find('.discount-item-newValue').text(parent_item.new_value);
            $('#product-' + parent_item.id).find('.total-product').text(parent_item.total_product);
            if (parent_item.contribution) {
                $('#product-' + parent_item.id).find('.contribution-item').text(parent_item.contribution); 
            } 
        }

        $('.order-info').find('.products-price').text(order.products_price);
        $('.order-info').find('.shipping-price').text(order.shipping_price);
        $('.order-info').find('.discount').text(order.discount);
        $('.order-info').find('.price').text(order.price);

        if (order.contribution_value) {
            $('.order-info').find('.contribution-total-percent').text(order.contribution_percent) 
            $('.order-info').find('.contribution-total-value').text(order.contribution_value)
        }

    }).catch((error) => classUtilitites.showCommunicationError(error));
}

function insertOrderProduct() {
    
    const el = $(this);

    var allowed = true;
    var link = $(this).data('link');

    $('.component-qty').each(function () {
        if (($(this).attr('min') > $(this).val()) || ($(this).attr('max') < $(this).val())) {
            allowed = false;
        }
    });

    $('.selected-component').each(function () {
        if ($(this).hasClass('required') && $(this).html().trim().length == 0) {
            allowed = false;
        }
    });

    $('input').each(function () {
        if ($(this).attr('required') != undefined && $(this).val() == "") {
            allowed = false;
        }
    });

    $('select').each(function () {
        if ($(this).attr('required') != undefined && $(this).val() == "") {
            allowed = false;
        }
    });

    if (!allowed) {
        showAlert(msg_error_component_selected, "Ok");
    } else {

        el.closest('form').removeClass('check-save');

        // el.addClass('d-none');
        el.attr('disable', 'disable');
        el.html('<i class="spinner" style="left: -9px;"></i>');

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: link,
            data: $(".form").serialize(),
            dataType: "json",
            success: function (data) {

                if (data.error) {
                    showAlert(data.message, "Ok", "error");
                    el.html(el.data('html'));
                    el.removeAttr('disable');
                } else {
                    /* showAlert(data.message, "Ok", "success");
                    setTimeout(function () {
                    }, 1000); */
                    window.location.href = data.result.target;
                }


            },
            error: function (jqXHR, textStatus, errorThrown) {
                showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }
}

function showAlert(msg, btn = "", icon = "error") {
    var attr_msg = {
        text: msg,
        icon: icon,
        buttonsStyling: false,
        customClass: {
            confirmButton: "btn font-weight-bold btn-light"
        }
    };

    if (btn != "") {
        attr_msg.confirmButtonText = btn;
    }

    Swal.fire(attr_msg).then(function () {
        KTUtil.scrollTop();
        setTimeout(() => {
            $('button.close').trigger('click');
        }, 1000);
    });
}

function productsAuxiliaries() {
    const el = $(this);
    const product_id = el.val();
    var url = el.data('url');

    url = url.replace('/replace', "/" + product_id);

    $('.products-auxiliaries-selected').remove();
    $('.info-products-auxiliaries').removeClass('hide');

    window.location.replace(url);
}

function giftCardType() {
    const el = $(this);
    $('#giftCardDiscount, #giftCardPercent').addClass('d-none');

    if (el.val() == 'percent') {
        $('#giftCardPercent').removeClass('d-none');
    }

    if (el.val() == 'value') {
        $('#giftCardDiscount').removeClass('d-none');
    }
}

function checkPercent() {
    const el = $(this);

    var value = el.val();
    value = value.replace(',', '.');

    if (value > 100) {
        el.val(100);
    }
}

function saveGiftCard() {
    const el = $(this);

    el.attr('disable', 'disable');

    const url = el.data('url');

    var value = 0;
    var type = $('input[name="giftCardType"]:checked').val();

    if (type == 'percent') {
        value = $('#giftCardPercent').val();
    }

    if (type == 'value') {
        value = $('#giftCardDiscount').val();
    }

    var data = {
        'type': type,
        'value': value
    };

    axios.post(url, data)
        .then(function (response) {
            const data = response.data

            // el.removeAttr('disable');
            classUtilitites.switchReturns(data, el);

        });
}

function saveFocusout() {
    let element = $(this);
    let id = element.closest('tr').data('id');

    let url = '/proposal/item/order-item/' + id;
    if (element.data('url')) {
        url = element.data('url');
    }

    let index = element.attr('name');
    let value = element.val();

    let params = {
        [index]: value
    };

    Loader.wrap(Axios.post(url, params))
        .catch((error) => classUtilitites.showCommunicationError(error));
}

function sortMultiItems() {
    if ($('.sort-item').length == 0) {
        return false;
    }

    let sort = new Array;
    $('.sort-item').each(function (index) {
        let el = $(this);

        let item = {
            'order_item_id': el.data('id'),
            'value': el.val()
        }        

        sort[index] = item;
    });

    let url = $('.sort-item').data('url');
    let data = { 'sort': sort };

    let touch = $(this);    
    if (touch.length > 0) {
        data.touch = {
            'order_item_id': touch.data('id'),
            'value': touch.val()
        }
    }

    Loader.wrap(axios.post(url, data))
        .then(function(response){
            const data = response.data;

            if (data.error === false) {
                const result = data.result;

                if (touch.length > 0) {
                    // o finally do wrap já fechou o overlay; reabre até o reload terminar
                    Loader.show();
                    location.reload();
                }else{
                    Object.keys(result).forEach(function(order_item_id) {
                        let sort = result[order_item_id];

                        $('#sort-item-' + order_item_id).val(sort);
                    });
                }
            }
        })
        .catch((error) => classUtilitites.showCommunicationError(error));
}

function accordionCompositionsShow(){
    $('#accordion-compositions').on('show.bs.collapse', function (accordion) {
        let target = $(accordion.target);
    
        if (target.hasClass('loaded-composition') === false) {
            axios.get(target.data('url'))
                .then(function(response){
                    let data = response.data;

                    if (data.error == false) {
                        let result = data.result;

                        target.addClass('loaded-composition');
                        target.find('.response-composition').html(result.html);
                        classUtilitites.formSelects();

                    }
                });
        }
    });
}

function removeCompositionResume(){
    let el = $(this);

    let composition_id = el.data('id');
    $('#resume-composition-' + composition_id).find('.text-init').show();
    $('#resume-composition-' + composition_id).find('.box-item').html("");

    classUtilitites.calculateComposition();
}

function toggleCapaPrintProposal() {
    let _this = $(this);
    let wrapCapa = "#wrap-list-capas";
    
    $(wrapCapa + ' input[type=radio]').prop('checked',false);

    if(_this.is(':checked')) {
        $(wrapCapa + ' input[type=radio]').first().prop('checked',true);
        $(wrapCapa).fadeToggle();
    }
}

function checkOpportunityOrder(){
    let el = $('.response-btn-opportunity-order');

    let url = el.data('ajax');
    axios.post(url).then(function(response){
        let data = response.data;

        if (data.error === false) {
            el.html(data.result.html);
        }        
    });
}

function checkDiffBetweenVersion(){
    let el = $('.resposne-diff-between-version');

    let url = el.data('ajax');
    axios.post(url).then(function(response){
        let data = response.data;

        if (data.error === false) {
            el.html(data.result.html);
        }        
    });
}

const scrollTopDownPage = (e) => {

    const _this             = $(e.currentTarget);
    let scrollDirection     = _this.attr('data-page-scroll');
    let offsetScroll        = '';
    const _parentScroll     = $("#kt_content");
    
    if(scrollDirection == 'up'){
        offsetScroll = _parentScroll.offset().top;
    }else{
        offsetScroll = _parentScroll.position().top + _parentScroll.offset().top + _parentScroll.outerHeight(true);;
    }
    $("html, body").animate({ scrollTop: offsetScroll }, "slow");

}

$(document).ready(function () {
    $(document).on('click', '.save-gift-card', saveGiftCard)
    $(document).on('change', 'input[name="giftCardType"]', giftCardType)
    $(document).on('focusout', 'input[name="percent_discount"]', checkPercent)
    $(document).on("click", ".component-qty", componentQty);
    $(document).on("click", ".qtyChange", qtyChange);
    $(document).on("click", ".insert-order-product", insertOrderProduct);
    $(document).on("change", ".discount-item", discountItem);
    $(document).on("change", '.products-auxiliaries-selected', productsAuxiliaries);
    $(document).on("focus", ".discount-item", function () {
        $(this).select();
    });
    $(document).on('focusout', '.save-focusout', saveFocusout);
    $(document).on('change', '.sort-item', sortMultiItems);
    $(document).on('focusout', '.qty-product', qtyProduct);
    sortMultiItems();
    $(document).on("click", ".js-toggle-capa-print", toggleCapaPrintProposal);
    $(document).on("click", ".btn-scrollpage", scrollTopDownPage);

    if ($('#accordion-compositions').length > 0) {
        accordionCompositionsShow();
        $(document).on('click', '.remove-composition-resume', removeCompositionResume);
    }

    if ($('.response-btn-opportunity-order').length > 0) {
        checkOpportunityOrder();
    }
    
    if ($('.resposne-diff-between-version').length > 0) {
        checkDiffBetweenVersion();
    }
});